import {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';
import axios from "axios";

const usePageLoading = (): boolean => {
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const location = useLocation();

    useEffect(() => {
        setIsLoading(true);
        const timer = setTimeout(() => {
            setIsLoading(false);
        }, 1000);

        const requestInterceptor = axios.interceptors.request.use((config) => {
            setIsLoading(true);
            return config;
        }, (error) => {
            setIsLoading(false);
            return Promise.reject(error);
        });

        const responseInterceptor = axios.interceptors.response.use((response) => {
            setIsLoading(false);
            return response;
        }, (error) => {
            setIsLoading(false);
            return Promise.reject(error);
        });
        return () => {
            clearTimeout(timer);
            axios.interceptors.request.eject(requestInterceptor);
            axios.interceptors.response.eject(responseInterceptor);
        };
    }, [location]);

    return isLoading;
};

export default usePageLoading;